__turbopack_context__.v({
  "cell": "FoundingWall-module__pG50gq__cell",
  "count": "FoundingWall-module__pG50gq__count",
  "engraving": "FoundingWall-module__pG50gq__engraving",
  "footnote": "FoundingWall-module__pG50gq__footnote",
  "linked": "FoundingWall-module__pG50gq__linked",
  "logo": "FoundingWall-module__pG50gq__logo",
  "mark": "FoundingWall-module__pG50gq__mark",
  "name": "FoundingWall-module__pG50gq__name",
  "plaque": "FoundingWall-module__pG50gq__plaque",
  "section": "FoundingWall-module__pG50gq__section",
  "skeleton": "FoundingWall-module__pG50gq__skeleton",
  "waitingMark": "FoundingWall-module__pG50gq__waitingMark",
  "wall": "FoundingWall-module__pG50gq__wall",
});
